var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"barWrapper",attrs:{"fluid":"","fill-height":"","ma-0":"","pa-0":""}},[_c('loading-circle',{attrs:{"show":_vm.loader}}),_vm._v(" "),_c('device-bar',{attrs:{"open":true,"noclose":"","modalMode":"","modalActive":_vm.getData},on:{"update":function($event){},"load-devices":function($event){},"close":function($event){}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }